<button
  class="primary-btn {{disabled ? 'disabled-btn': ''}}"
  mat-button
  color="primary"
  [ngClass]="size"
  [disabled]="disabled"
  [ngStyle]=" backgroundColor ? {'background': backgroundColor} : {}"
  (click)="onClick($event)">
  <span *ngIf="!loading; else loader"  [@elemShow]>
    {{text}}
  </span>
  <ng-template #loader>
      <dn-loader [loaderSize]="size" />
  </ng-template>
</button>
